import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-skill",
  templateUrl: "./skill.component.html",
  styleUrls: ["./skill.component.css"],
})
export class SkillComponent implements OnInit {
  SkillIcons = Array<any>();
  constructor() {}

  ngOnInit(): void {
    this.SkillIcons = new Array<any>();
    this.SkillIcons = [
      { icon: "devicon-android-plain-wordmark", toolTip: "Android" },
      { icon: "devicon-angularjs-plain", toolTip: "Angular" },
      // { icon: "devicon-bitbucket-original", toolTip: "BitBucket" },
      { icon: "devicon-bootstrap-plain-wordmark", toolTip: "Bootstrap" },
      { icon: "devicon-csharp-plain-wordmark", toolTip: "csharp" },
      { icon: "devicon-css3-plain-wordmark", toolTip: "CSS3" },
      { icon: "devicon-dart-plain-wordmark", toolTip: "Dart" },
      { icon: "devicon-dot-net-plain-wordmark", toolTip: "ASP.Net" },
      { icon: "devicon-dotnetcore-plain", toolTip: ".Net Core" },
      { icon: "devicon-express-original-wordmark", toolTip: "Express JS" },
      { icon: "devicon-flutter-plain", toolTip: "Flutter" },
      { icon: "devicon-git-plain-wordmark", toolTip: "Git" },
      { icon: "devicon-github-original-wordmark", toolTip: "Github" },
      { icon: "devicon-graphql-plain-wordmark", toolTip: "GraphQL" },
      { icon: "devicon-html5-plain-wordmark", toolTip: "HTML5" },
      { icon: "devicon-javascript-plain", toolTip: "JavaScript" },
      { icon: "devicon-jest-plain", toolTip: "Jest" },
      { icon: "devicon-jquery-plain-wordmark", toolTip: "JQuery" },
      { icon: "devicon-mongodb-plain-wordmark", toolTip: "Mongo" },
      { icon: "devicon-mysql-plain-wordmark", toolTip: "MYSql" },
      { icon: "devicon-nodejs-plain-wordmark", toolTip: "NodeJS" },
      { icon: "devicon-npm-original-wordmark", toolTip: "NPM" },
      { icon: "devicon-microsoftsqlserver-plain-wordmark", toolTip: "SQL Server" },
      { icon: "devicon-typescript-plain", toolTip: "TypeScript" },
      { icon: "devicon-vuejs-plain-wordmark", toolTip: "VUE JS" },
      { icon: "devicon-windows8-original", toolTip: "Windows Application" },
    ];
  }
}
